import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=d129cf92&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d129cf92')) {
      api.createRecord('d129cf92', component.options)
    } else {
      api.reload('d129cf92', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=d129cf92&", function () {
      api.rerender('d129cf92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/Common/Contacts.vue"
export default component.exports